import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  @Input() user;
  public userFullName: string;
  constructor() {}

  ngOnInit() {
    this.userFullName = `${this.user.name} ${this.user.surname}`;
  }

  get isAgentTalkState() {
    return !!this.user.agentState;
  }

  get classBasedOnUserState() {
    if (this.isAgentTalkState) {
      switch (this.user.agentState) {
        case 'IDLE':
          return 'on';
        case 'WAITING':
        case 'PAUSED':
        case 'BUSY':
        default:
          return 'away';
      }
    } else if (!this.isAgentTalkState) {
      switch (this.user.state) {
        case 'ACTIVE':
          return 'on';
        case 'PENDING':
          return 'talking';
        case 'INACTIVE':
        default:
          return 'away';
      }
    }
  }
}
